// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var _a, _b;
export var VotesTimeResolution;
(function (VotesTimeResolution) {
    VotesTimeResolution["MINUTE"] = "minute";
    VotesTimeResolution["HOUR"] = "hour";
    VotesTimeResolution["DAY"] = "day";
})(VotesTimeResolution || (VotesTimeResolution = {}));
export var VotesTimeRange;
(function (VotesTimeRange) {
    VotesTimeRange["FIFTEEN_MINUTES"] = "15m";
    VotesTimeRange["ONE_HOUR"] = "1h";
    VotesTimeRange["SIX_HOURS"] = "6h";
    VotesTimeRange["TWENTY_FOUR_HOURS"] = "24h";
    VotesTimeRange["SEVEN_DAYS"] = "7d";
    VotesTimeRange["THIRTY_DAYS"] = "30d";
    VotesTimeRange["NINETY_DAYS"] = "90d";
})(VotesTimeRange || (VotesTimeRange = {}));
var votesTimeResolutions = new Set(Object.values(VotesTimeResolution));
var votesTimeRanges = new Set(Object.values(VotesTimeRange));
export var isVotesTimeResolution = function (value) {
    return votesTimeResolutions.has(value);
};
export var isVotesTimeRange = function (value) {
    return votesTimeRanges.has(value);
};
export var VOTES_TIME_RANGE_OPTIONS = (_a = {},
    _a[VotesTimeResolution.MINUTE] = [
        {
            value: VotesTimeRange.FIFTEEN_MINUTES,
            label: VotesTimeRange.FIFTEEN_MINUTES,
            bucketCount: 15,
        },
        { value: VotesTimeRange.ONE_HOUR, label: VotesTimeRange.ONE_HOUR, bucketCount: 60 },
        { value: VotesTimeRange.SIX_HOURS, label: VotesTimeRange.SIX_HOURS, bucketCount: 360 },
    ],
    _a[VotesTimeResolution.HOUR] = [
        {
            value: VotesTimeRange.TWENTY_FOUR_HOURS,
            label: VotesTimeRange.TWENTY_FOUR_HOURS,
            bucketCount: 24,
        },
        { value: VotesTimeRange.SEVEN_DAYS, label: VotesTimeRange.SEVEN_DAYS, bucketCount: 168 },
        { value: VotesTimeRange.THIRTY_DAYS, label: VotesTimeRange.THIRTY_DAYS, bucketCount: 720 },
    ],
    _a[VotesTimeResolution.DAY] = [
        { value: VotesTimeRange.SEVEN_DAYS, label: VotesTimeRange.SEVEN_DAYS, bucketCount: 7 },
        { value: VotesTimeRange.THIRTY_DAYS, label: VotesTimeRange.THIRTY_DAYS, bucketCount: 30 },
        { value: VotesTimeRange.NINETY_DAYS, label: VotesTimeRange.NINETY_DAYS, bucketCount: 90 },
    ],
    _a);
var DEFAULT_RANGE = (_b = {},
    _b[VotesTimeResolution.MINUTE] = VotesTimeRange.ONE_HOUR,
    _b[VotesTimeResolution.HOUR] = VotesTimeRange.TWENTY_FOUR_HOURS,
    _b[VotesTimeResolution.DAY] = VotesTimeRange.SEVEN_DAYS,
    _b);
export var DEFAULT_VOTES_TIME_SELECTION = {
    resolution: VotesTimeResolution.DAY,
    range: DEFAULT_RANGE[VotesTimeResolution.DAY],
};
export function getVotesTimeRangeOptions(resolution) {
    return VOTES_TIME_RANGE_OPTIONS[resolution];
}
export function withVotesTimeResolution(resolution) {
    return {
        resolution: resolution,
        range: DEFAULT_RANGE[resolution],
    };
}
export function getVotesBucketCount(selection) {
    var _a, _b;
    var options = getVotesTimeRangeOptions(selection.resolution);
    return ((_b = (_a = options.find(function (_a) {
        var value = _a.value;
        return value === selection.range;
    })) === null || _a === void 0 ? void 0 : _a.bucketCount) !== null && _b !== void 0 ? _b : options.find(function (_a) {
        var value = _a.value;
        return value === DEFAULT_RANGE[selection.resolution];
    }).bucketCount);
}
